import React from 'react';
import { FiX, FiTool } from 'react-icons/fi';
import styles from './Emitir.module.css';
import useEsc from '../../../hooks/useEsc';

const moeda = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

/* Tomador com mais de um serviço cadastrado: escolhe qual vai pra esta nota.
   Descrição e valor do escolhido preenchem a emissão e seguem editáveis. */
function ModalServicoTomador({ tomador, servicos, onEscolher, onFechar }) {
  useEsc(onFechar);
  return (
    <div className={styles.modalFundo}>
      <div className={styles.modalCaixa} style={{ maxWidth: 560 }} onClick={e => e.stopPropagation()}>
        <div className={styles.modalTopo}>
          <div>
            <h3 className={styles.modalTitulo}>Qual serviço vai nesta nota?</h3>
            <p className={styles.modalSub}>{tomador?.nome} tem {servicos.length} serviços cadastrados.</p>
          </div>
          <button type="button" className={styles.btnIcone} onClick={onFechar}><FiX size={16} /></button>
        </div>
        <div className={styles.modalCorpo}>
          {servicos.map((s, i) => (
            <button key={i} type="button" className={styles.tomadorItem} onClick={() => onEscolher(s)}>
              <span className={styles.tomadorIcone}><FiTool size={13} /></span>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span className={styles.tomadorNome}>{s.descricao || `Serviço ${i + 1}`}</span>
                <span className={styles.tomadorDoc}>
                  {Number(s.quantidade) > 0 ? `${moeda(s.valorUnitario)} × ${String(s.quantidade).replace('.', ',')} = ` : ''}{moeda(s.valor)}
                </span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ModalServicoTomador;
